import type { JSX } from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';

import { PromoteYourPetition } from './components/PromoteYourPetition';
import { ShareVisual } from './components/ShareVisual';
import { ShareYourPetition } from './components/ShareYourPetition';
import { ShareYourPetitionOffline } from './components/ShareYourPetitionOffline';
import { useGrowPetition } from './hooks/useGrowPetition';

export function GrowPetition(): JSX.Element {
	const { data } = useGrowPetition();

	return (
		<Box as="section" role="group" aria-labelledby="grow-petition-title">
			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: ['1fr', '1fr 1fr'],
					gridGap: 16,
				}}
			>
				<ShareYourPetition />
				<ShareYourPetitionOffline />
				<Box sx={{ gridColumn: ['1/1', '1/3'] }}>
					<ShareVisual />
				</Box>
				{data.shouldShowPromoteYourPetition && (
					<Box sx={{ gridColumn: ['1/1', '1/3'] }}>
						<PromoteYourPetition />
					</Box>
				)}
			</Box>
		</Box>
	);
}
